import { Component, OnInit } from '@angular/core';
import {UsersService} from '../../../core/users/users.service';
import {AuthService} from '../../../core/auth/auth.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  users: any[];
  page: number;
  prevBtn: boolean;
  nextBtn: boolean;
  sortField: string;
  sortReverse: boolean;
  activeArrow: object[];
  showSpinner: boolean;


  constructor(private usersService: UsersService, private authService: AuthService) { }

  ngOnInit() {
    this.page=0;
    this.prevBtn = true;
    this.nextBtn = false;
    this.setSortField("name");
    this.sortReverse = false;
    this.activeArrow=[{},{color: "rgba(55, 153, 233, 0.959)"},{},{},{},{}];
    this.showSpinner=true;
    this.usersService.list(this.page,this.sortField,this.sortReverse)
      .subscribe((users: any[]) => {
        console.log(users);
        this.users = users.slice(0,10);
        console.log(this.users);
        this.showSpinner=false;
      });
  }

  setSortField(field){
    this.sortField=field;
  }

  setArrowActive(field){
    if(this.sortReverse){
      if(field==='name'){
        this.activeArrow=[{color: "rgba(55, 153, 233, 0.959)"},{},{},{},{},{}];
      }
      else if(field==='planStart'){
        this.activeArrow=[{},{},{color: "rgba(55, 153, 233, 0.959)"},{},{},{}];
      }
      else if(field==='planExpiration'){
        this.activeArrow=[{},{},{},{},{color: "rgba(55, 153, 233, 0.959)"},{}];
      }
    }
    else{
      if(field==='name'){
        this.activeArrow=[{},{color: "rgba(55, 153, 233, 0.959)"},{},{},{},{}];
      }
      else if(field==='planStart'){
        this.activeArrow=[{},{},{},{color: "rgba(55, 153, 233, 0.959)"},{},{}];
      }
      else if(field==='planExpiration'){
        this.activeArrow=[{},{},{},{},{},{color: "rgba(55, 153, 233, 0.959)"}];
      }
    }
  }

  toggleSortUp(field){
    this.setSortField(field);
    this.sortReverse=true;
    this.page=0;  
    this.prevBtn = true;
    this.nextBtn = false;
    this.showSpinner=true;
    this.usersService.list(this.page,this.sortField,this.sortReverse)
      .subscribe((users: any[]) => {
        this.users = users.slice(0,10);
        this.showSpinner=false;
      });
    this.setArrowActive(field);
  }
  toggleSortDown(field){
    this.setSortField(field);
    this.sortReverse=false;
    this.page=0;  
    this.prevBtn = true;
    this.nextBtn = false;
    this.showSpinner=true;
    this.usersService.list(this.page,this.sortField,this.sortReverse)
      .subscribe((users: any[]) => {
        this.users = users.slice(0,10);
        this.showSpinner=false;
      });
    this.setArrowActive(field);
  }

  nextPage() {
    this.page = this.page + 1;
    this.prevBtn = false;
    this.showSpinner=true;
    this.usersService.list(this.page,this.sortField,this.sortReverse)
      .subscribe((users: any[]) => {
        if(users.length<11){
          this.nextBtn = true;
        }
      this.users = users.slice(0,10);
      this.showSpinner=false;
      });
    
  }

  prevPage() {
    this.page = this.page - 1;
    if(this.page>=0 ){
      this.showSpinner=true;
      this.usersService.list(this.page,this.sortField,this.sortReverse)
      .subscribe((users: any[]) => {
        this.users = users.slice(0,10);
        this.nextBtn = false;
        this.showSpinner=false;
      });
      if(this.page===0){
        this.prevBtn = true;
      }
    }
    else{
      this.page = this.page+1;
    }
    
  }

  onToggleActive(user) {
    this.usersService.edit(user._id, {active: !user.active})
      .subscribe((editedUser: any) => {
        this.users = this.users.map(u => {
          if (u._id === editedUser._id) {
            return editedUser;
          } else {
            return u;
          }
        });
      });
  }

  onChangePassword({user, password}) {
    this.usersService.edit(user._id, { password })
      .subscribe(() => {}, (err) => {
        alert(err.error.message || 'An error occurred');
      });
  }

  onChangeChildren(children, user) {
    this.usersService.edit(user._id,{ children })
      .subscribe(data => {
        this.users = this.users.map(u => {
          if (u._id === user._id) {
            return data;
          } else {
            return u;
          }
        });
        if (this.authService.getProfile()._id === user._id) {
          this.authService.setProfile(data);
        }
      });
  }

  onDelete(user) {
    this.usersService.delete(user._id)
      .subscribe(() => {
        this.users = this.users.filter(u => u._id !== user._id);
      }, (err) => {
        alert(err.error.message || 'An error occurred');
    });
  }

  onChangePlan(data, user) {
    this.usersService.edit(user._id, data)
      .subscribe((editedUser: any) => {
        this.users = this.users.map(u => {
          if (u._id === editedUser._id) {
            return editedUser;
          } else {
            return u;
          }
        });
        if (this.authService.getProfile()._id === user._id) {
          this.authService.updateProfile(data);
        }
      }, (err) => {
        alert(err.error.message || 'An error occurred');
      });

  }

  

}



// WEBPACK FOOTER //
// ./client/app/components/settings/users/users.component.ts